import type { Mail } from '@/lib/data'

/** localStorage key for optional channel pins (Entrega 3 inbox). */
export const INBOX_PINNED_CHANNEL_KEYS_STORAGE = 'rk_inbox_pinned_channel_keys_v1'

const CHANNEL_KEY_TO_MAIL_PLATFORM: Record<string, Mail['platform']> = {
  Betterplace: 'betterplace',
  Web: 'web',
  WhatsApp: 'whatsapp',
  'Phone Call': 'phone_call',
  Instagram: 'instagram',
  Facebook: 'facebook',
  Twitter: 'twitter',
  WordPress: 'wordpress',
  Avatar: 'avatar',
  Other: 'other',
}

export function channelKeyToMailPlatform(key: string): Mail['platform'] {
  return CHANNEL_KEY_TO_MAIL_PLATFORM[key] ?? 'other'
}

/** Map registry `key` (e.g. "Avatar") to existing filter tab ids used by ConversationsPage. */
export function registryKeyToSelectedId(key: string): string {
  if (key === 'Betterplace') return 'betterplace'
  if (key === 'Web') return 'web'
  if (key === 'WhatsApp') return 'whatsapp'
  if (key === 'Phone Call') return 'phone_call'
  return `registry:${key}`
}

/** Inverse: derive conversations API `source` filter value from the active tab id. */
export function selectedIdToSourceFilter(selectedPlatform: string): string | null {
  if (selectedPlatform.startsWith('registry:')) {
    return selectedPlatform.slice('registry:'.length)
  }
  if (selectedPlatform === 'betterplace') return 'Betterplace'
  if (selectedPlatform === 'web') return 'Web'
  if (selectedPlatform === 'whatsapp') return 'WhatsApp'
  if (selectedPlatform === 'phone_call') return 'Phone Call'
  return null
}

export function readPinnedChannelKeys(): string[] {
  try {
    const raw = localStorage.getItem(INBOX_PINNED_CHANNEL_KEYS_STORAGE)
    if (!raw) return []
    const parsed = JSON.parse(raw) as unknown
    if (!Array.isArray(parsed)) return []
    return parsed.filter((x): x is string => typeof x === 'string' && x.length > 0)
  } catch {
    return []
  }
}

export function writePinnedChannelKeys(keys: string[]): void {
  try {
    localStorage.setItem(INBOX_PINNED_CHANNEL_KEYS_STORAGE, JSON.stringify(keys))
  } catch {
    /* ignore quota / private mode */
  }
}
